import { AlignStyle } from "@modules/whiteboard/types"

const ALIGN_VALUES = {
  'start': 'left',
  'middle': 'center',
  'end': 'right',
  'justify': 'justify',
} as const

export function getTextAlign(alignStyle: AlignStyle = 'start') {
  return ALIGN_VALUES[alignStyle]
}


// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/shared/getTextAlign.tsx